import React, { useRef } from 'react';
import {ConnectButton} from '@rainbow-me/rainbowkit';
import NereusButton from '../NereusButton/NereusButton';
// @ts-ignore
import jazzicon from '@metamask/jazzicon';

import './NereusConnectButton.scss';
import {useSwitchChainToBase} from "../../hooks/useSwitchChainToBase";
import {base} from "viem/chains";

export interface NereusConnectButtonProps {
    children?: React.ReactNode;
    bridgeButton?: React.ReactNode;
    isDepositBlock?: boolean;
}

/* Function from metamask repository itself */
function jsNumberForAddress(address: string): number {
    const addr = address.slice(2, 10);
    const seed = parseInt(addr, 16);
    return seed;
}

const NereusConnectButton = ({ children, bridgeButton }: NereusConnectButtonProps) => {

    const switchChainToBase = useSwitchChainToBase();

    const jazzIconRef = useRef<HTMLDivElement | null>(null);

    return (
        <ConnectButton.Custom>
            {({
                  account,
                  chain,
                  openAccountModal,
                  openChainModal,
                  openConnectModal,
                  authenticationStatus,
                  mounted,
              }) => {
                const ready = mounted && authenticationStatus !== 'loading';
                const connected =
                    ready &&
                    account &&
                    chain &&
                    (!authenticationStatus ||
                        authenticationStatus === 'authenticated');

                const jazzIcon = jazzicon(24, account ? jsNumberForAddress(account.address) : 0);

                if (jazzIconRef.current) {
                    jazzIconRef.current.innerHTML = '';
                    jazzIconRef.current.appendChild(jazzIcon)
                }

                return (
                    <div
                        {...(!ready && {
                            'aria-hidden': true,
                            'style': {
                                opacity: 0,
                                pointerEvents: 'none',
                                userSelect: 'none',
                            },
                        })}
                    >
                        {(() => {
                            if (!connected) {
                                return (
                                <NereusButton
                                    className={`flex-1 long-btn active NereusConnectButton__connectBtn`}
                                    variant="contained"
                                    onClick={openConnectModal}
                                >
                                    Connect&nbsp;Wallet
                                </NereusButton>);
                            }

                            if (chain.unsupported || chain.id !== base.id) {
                                const wrongNetworkButton = (
                                    <NereusButton
                                        onClick={switchChainToBase}
                                        className={`flex-1 long-btn active NereusConnectButton__wrongNetwork`}
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        Wrong&nbsp;network
                                    </NereusButton>
                                )
                                return (
                                    bridgeButton
                                        ? (
                                            <div className="flex gap-4">
                                                {bridgeButton}
                                                {wrongNetworkButton}
                                            </div>
                                        )
                                        : wrongNetworkButton
                                );
                            }

                            if (children) {
                                return children;
                            }

                            return (
                                <div style={{display: 'flex', gap: 20}}>
                                    <div style={{display: 'flex', alignItems: 'center', color: "white"}}>
                                        <div
                                            className="NereusConnectButton__chainIcon"
                                            style={{
                                                width: 24,
                                                height: 24,
                                                borderRadius: 999,
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {chain.iconUrl && (
                                                <img
                                                    alt="Base"
                                                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgPGNpcmNsZSBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiIGZpbGw9IiMwMDUyRkYiLz4KICA8ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAiPjxjaXJjbGUgY3g9IjMyIiBjeT0iMzIiIHI9IjMyIi8+PC9jbGlwUGF0aD48L2RlZnM+CiAgPHJlY3QgeD0iMCIgeT0iMzAiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0iI0ZGRkZGRiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXApIi8+Cjwvc3ZnPg=="
                                                    style={{ width: 24, height: 24 }}
                                                />
                                            )}
                                        </div>
                                        <span className="NereusConnectButton__chainName">Base</span>
                                    </div>

                                    <NereusButton
                                        onClick={openAccountModal}
                                        className={`flex-1 long-btn active flex items-center NereusConnectButton__addressBtn`}
                                        color="secondary"
                                    >
                                        <div className="NereusConnectButton__jazzIcon" ref={jazzIconRef} />
                                        {account.displayName}
                                    </NereusButton>
                                </div>
                            );
                        })()}
                    </div>
                );
            }}
        </ConnectButton.Custom>
    )
};

export default NereusConnectButton;
